//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { EventBus } from '../../EventBus/EventBus.js'

import BrigadeForkliftTruckField from './BrigadeForkliftTruck/BrigadeForkliftTruckField.vue'
import BrigadeMapBrigadeInformationEmployee from './BrigadeMapBrigadeInformationEmployee.vue'
import BrigadeMapBrigadeInformationVehicle from './BrigadeMapBrigadeInformationVehicle.vue'

export default {
  name: 'BrigadeMapBrigadeInformation',
  components: {
    BrigadeForkliftTruckField,
    BrigadeMapBrigadeInformationEmployee,
    BrigadeMapBrigadeInformationVehicle
  },
  props: {
    brigade: {
      type: Object,
      default: function () {
        return {}
      }
    },
    state: {
      type: String,
      default: 'Нет данных'
    },
    regions: {
      type: Array,
      default () {
        return []
      }
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      workAreasText: null,
      redirectedWorkAreasText: null
    }
  },
  computed: {
    notMobile: function () {
      return !this.mobile
    },
    workShift: function () {
      return this.brigade.workShift.alias || 'Нет данных'
    },
    workAreas: function () {
      return this.brigade.workAreas || []
    },
    autoRequestAssignLocal: {
      get: function () {
        return !!this.brigade.autoRequestAssign
      },
      set: function (value) {
        this.brigade.autoRequestAssign = !!value
        this.onChanged()
      }
    },
    ignoreVehicleReturnToStockAfterWorkShiftLocal: {
      get: function () {
        return !!this.brigade.ignoreVehicleReturnToStockAfterWorkShift
      },
      set: function (value) {
        this.brigade.ignoreVehicleReturnToStockAfterWorkShift = !!value
        this.onChanged()
      }
    },
    brigadeRegionsLocal: {
      get: function () {
        return this.brigade.regions || []
      },
      set: function (value) {
        this.brigade.regions = value
        this.onChanged()
      }
    },
    autoAssignOnlyWithForkliftTruckLocal: {
      get: function () {
        return this.brigade.autoAssignOnlyWithForkliftTruck
      },
      set: function (value) {
        this.brigade.autoAssignOnlyWithForkliftTruck = value
        this.onChanged()
      }
    },
    employees: function () {
      return this.brigade.employees
    },
    vehicles: function () {
      const employeesVehicles = []
      this.employees.forEach(employee => {
        employeesVehicles.push(...employee.vehicles)
      })
      return employeesVehicles
    },
    regionsLocal: function () {
      return this.regions.map(region => {
        return {
          id: region.id,
          name: region['param.shortName']
        }
      })
    }
  },
  watch: {
    workAreas: {
      handler: function (workAreas) {
        if (workAreas && workAreas.length) {
          this.workAreasText = workAreas.filter(workArea => workArea.main).map(workArea => workArea.name).join(', ')
          this.redirectedWorkAreasText = workAreas.filter(workArea => !workArea.main).map(workArea => workArea.name).join(', ')
        } else {
          this.workAreasText = 'Нет данных'
          this.redirectedWorkAreasText = 'Нет данных'
        }
      },
      immediate: true
    }
  },
  methods: {
    onUpdateForkliftTruck: function () {
      this.$emit('updated')
      EventBus.$emit('update-requestsQueue')
    },
    onChanged: function () {
      this.$emit('changed')
    }
  }
}

